import { useState, type FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/db7me2fidngsrf4ehn20';

type Status = 'idle' | 'submitting' | 'success' | 'error';

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') ?? '').trim();
    if (honeypot) {
      setStatus('success');
      setFormError('');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (typeof value === 'string' && value.trim() !== '') {
        params.append(key, value);
      }
    });

    setStatus('submitting');
    setFormError('');
    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(
          typeof serverMsg === 'string' && serverMsg.trim() !== ''
            ? serverMsg
            : '订阅失败，请稍后重试',
        );
      }
    } catch (error) {
      setStatus('error');
      setFormError('网络异常，请稍后重试');
    }
  };

  return (
    <div>
      <form
        data-readdy-form="newsletter"
        id="newsletter-signup-form"
        onSubmit={handleSubmit}
        className="flex w-full flex-col gap-2 sm:flex-row"
      >
        <input
          type="email"
          name="email"
          required
          placeholder="你的邮箱地址"
          className="h-11 min-w-0 flex-1 rounded-md border border-accent-700/60 bg-accent-900/40 px-4 text-sm text-background-50 outline-none transition-colors placeholder:text-background-200/70 focus:border-primary-400"
        />
        <input
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="visitor-check-row"
        />
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="flex h-11 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 cursor-pointer"
        >
          <i className="ri-mail-send-line"></i>
          {status === 'submitting' ? '订阅中...' : '订阅更新'}
        </button>
      </form>
      {status === 'success' && (
        <p className="mt-2 flex items-center gap-1 text-xs text-accent-200">
          <i className="ri-checkbox-circle-line"></i>
          订阅成功，最新的双女主韩漫更新会第一时间通知你。
        </p>
      )}
      {status === 'error' && (
        <p className="mt-2 flex items-center gap-1 text-xs text-primary-300">
          <i className="ri-error-warning-line"></i>
          {formError}
        </p>
      )}
    </div>
  );
}